import React from 'react';
import {UserRoutes} from '../routes';

export default function UserAccount() {
    return <UserRoutes/>;
}
